module.exports = __webpack_public_path__ + "static/media/xfinity-sell-fre.c7feaa56.png";